import { faker } from '@faker-js/faker'

import { TargetLanguage } from '../../contracts/service-offer'
import { AdminPricePropertyValueRequest } from '../../contracts/treatment/AdminPricePropertyRequest'
import { asBuilder } from '../asBuilder'

export const getAdminPricePropertyValueRequest = asBuilder((): AdminPricePropertyValueRequest => {
  const names = faker.helpers.multiple(
    () => ({
      language: faker.helpers.enumValue(TargetLanguage),
      value: faker.lorem.word(),
    }),
    { count: 3 },
  )

  return {
    propertyId: faker.string.uuid(),
    names,
  }
})
